/// <amd-module name="SearchUI/Components/SearchResultItemComponent/SearchResultItemComponent.Props" />

export interface SearchResultItemProps {
    /**
    * Title component
    */
    titleComponent: JSX.Element;
    
    /**
    * Component for title meta data like "likes" or title version.
    */
    titleMetaDataComponent?: JSX.Element;

    /**
    * Component for subtitle.
    */
    subTitleComponent?: JSX.Element;

    /**
    * Component for description/content.
    */
    descriptionComponent: JSX.Element;

    /**
    * Component for tags.
    */
    tagsComponent?: JSX.Element;

    /**
    * Image component.
    */
    imageComponent?: JSX.Element;

    /**
    * Component for meta data like Sparklines.
    */
    resultRightSectionComponent?: JSX.Element;

	/**
	* On click of file name
	*/
	onFileNameClicked?: (link: string, evt: React.MouseEvent<HTMLAnchorElement> | React.KeyboardEvent<HTMLAnchorElement>) => void;
}
